<!--Carousel appropriate for upcoming calendar events
    Required:
    - At least one upcoming event/recent news/blog to display
        - Event requires title, image, description, date(s), time(s), and link
        - News/Blog requires title, image, description, and link
    - Desired color for background of carousel banner
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid class="py-5 px-2">
      <mdb-container v-if="block.value.title_and_text">
        <mdb-row>
          <mdb-col>
            <h2 v-if="block.value.title_and_text.title" class="text-center pb-2">
              <strong>{{block.value.title_and_text.title}}
              </strong>
            </h2>
            <p v-if="block.value.title_and_text.text">{{block.value.title_and_text.text}}</p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
      <mdb-carousel
        :items="block.value.carousel_info.length"
        multi
        indicators
        touch
        slide
        :interval="9000"
        >
        <template #[i+1] v-for="(block, i) in block.value.carousel_info"> 
          <component :is="block.type" :block="block" :key="i"></component>
        </template>
      </mdb-carousel>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCarousel,
    mdbCardGroup
} from "mdbvue"
import information_block from "@/components/streamfields/landingPageComponents/info_carousel/information_block.vue"
export default {
    name: "information_carousel",
    props: {
        block: Object
    },
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCarousel,
        mdbCardGroup,
        information_block
    }
};
</script>